var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup-header-tool"},[_c('div',{staticClass:"empty"}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"close-btn",attrs:{"src":require("../../assets/img/public/popup_close.png"),"alt":"关闭"},on:{"click":_vm.close}})])
}
var staticRenderFns = []

export { render, staticRenderFns }